import { useEffect, useState } from 'react';
import { usePageVisibility } from './usePageVisibility';
import { useWakeLock } from './useWakeLock';

export interface UseAutoWakeLockResponse {
  isLocked: boolean;
}

export const useAutoWakeLock = (
  document: Document = window.document
): UseAutoWakeLockResponse => {
  const { isVisible } = usePageVisibility(document);
  const [isLocked, setIsLocked] = useState(false);
  const { isSupported, release, request } = useWakeLock({
    onRelease: () => {
      setIsLocked(false);
    },
    onRequest: () => {
      setIsLocked(true);
    },
  });

  useEffect(() => {
    if (isVisible && isLocked) {
      return;
    }
    if (!isVisible && !isLocked) {
      return;
    }
    if (isVisible) {
      request().catch((e) => {
        console.log(e);
      });
    } else {
      release().catch((e) => {
        console.log(e);
      });
    }
  }, [isVisible, isLocked, release, request]);

  if (!isSupported) {
    return {
      isLocked: false,
    };
  }

  return {
    isLocked,
  };
};
